export var SortMode;
(function (SortMode) {
    SortMode["OFF"] = "OFF";
    SortMode["ASC"] = "ASC";
    SortMode["DESC"] = "DESC";
})(SortMode || (SortMode = {}));
//# sourceMappingURL=data-table.types.js.map